import { referenceRatesMessages } from 'src/features/referenceRates/utils/messages';
import { REFERENCE_RATE_UNIT } from 'src/features/referenceRates/utils/types';

export const REFERENCE_RATE_UNIT_MAP: Record<REFERENCE_RATE_UNIT, { id: string; defaultMessage: string }> = {
    [REFERENCE_RATE_UNIT.CURRENCY]: referenceRatesMessages.unitCurrency,
    [REFERENCE_RATE_UNIT.PERCENT]: referenceRatesMessages.unitPercent,
    [REFERENCE_RATE_UNIT.COEFFICIENT]: referenceRatesMessages.unitCoefficient,
    [REFERENCE_RATE_UNIT.POINTS]: referenceRatesMessages.unitPoints,
};

/**
 * How many minor units make one whole unit. `ReferenceRateValue.amount` is always an integer: cents for a
 * currency rate, ten-thousandths for every other unit (103.5 points -> 1035000, 1.035 -> 10350, 3.5 % -> 35000).
 */
export const REFERENCE_RATE_UNIT_SCALE: Record<REFERENCE_RATE_UNIT, number> = {
    [REFERENCE_RATE_UNIT.CURRENCY]: 100,
    [REFERENCE_RATE_UNIT.PERCENT]: 10000,
    [REFERENCE_RATE_UNIT.COEFFICIENT]: 10000,
    [REFERENCE_RATE_UNIT.POINTS]: 10000,
};

/** Decimal places a value may be entered with - the exponent of the scale above. */
export const REFERENCE_RATE_UNIT_DECIMALS: Record<REFERENCE_RATE_UNIT, number> = {
    [REFERENCE_RATE_UNIT.CURRENCY]: 2,
    [REFERENCE_RATE_UNIT.PERCENT]: 4,
    [REFERENCE_RATE_UNIT.COEFFICIENT]: 4,
    [REFERENCE_RATE_UNIT.POINTS]: 4,
};
